/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type MuuidRetrievePrefix = typeof MuuidRetrievePrefix[keyof typeof MuuidRetrievePrefix];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MuuidRetrievePrefix = {
  AALE_: 'AALE_',
  ADDR_: 'ADDR_',
  AGRU_: 'AGRU_',
  ALGM_: 'ALGM_',
  ALGR_: 'ALGR_',
  ALLO_: 'ALLO_',
  ALRE_: 'ALRE_',
  ARGV_: 'ARGV_',
  ARUV_: 'ARUV_',
  BANK_: 'BANK_',
  CCFE_: 'CCFE_',
  CCTR_: 'CCTR_',
  CCUS_: 'CCUS_',
  CDCR_: 'CDCR_',
  CDEF_: 'CDEF_',
  CDFC_: 'CDFC_',
  CEEV_: 'CEEV_',
  CEJR_: 'CEJR_',
  CELY_: 'CELY_',
  CEVT_: 'CEVT_',
  CFAC_: 'CFAC_',
  CFBB_: 'CFBB_',
  CFBE_: 'CFBE_',
  CFBV_: 'CFBV_',
  CFFE_: 'CFFE_',
  CFIE_: 'CFIE_',
  CFLO_: 'CFLO_',
  CFLV_: 'CFLV_',
  CFPT_: 'CFPT_',
  CFVS_: 'CFVS_',
  CLOS_: 'CLOS_',
  CONT_: 'CONT_',
  CPFF_: 'CPFF_',
  CPUH_: 'CPUH_',
  CUSR_: 'CUSR_',
  CUST_: 'CUST_',
  DATE_: 'DATE_',
  DOCU_: 'DOCU_',
  DSFS_: 'DSFS_',
  DSTR_: 'DSTR_',
  EMAL_: 'EMAL_',
  EMTE_: 'EMTE_',
  EMTT_: 'EMTT_',
  ENTI_: 'ENTI_',
  EOPR_: 'EOPR_',
  EQUA_: 'EQUA_',
  ETVE_: 'ETVE_',
  EVCD_: 'EVCD_',
  EVET_: 'EVET_',
  EVIE_: 'EVIE_',
  EVLE_: 'EVLE_',
  EVOM_: 'EVOM_',
  EVOR_: 'EVOR_',
  EVTE_: 'EVTE_',
  EVTO_: 'EVTO_',
  EXTD_: 'EXTD_',
  FBCY_: 'FBCY_',
  FBDS_: 'FBDS_',
  FEAT_: 'FEAT_',
  FECE_: 'FECE_',
  FEEB_: 'FEEB_',
  FEEC_: 'FEEC_',
  FEEE_: 'FEEE_',
  FEEP_: 'FEEP_',
  FETU_: 'FETU_',
  FFAM_: 'FFAM_',
  FFCG_: 'FFCG_',
  FFEN_: 'FFEN_',
  FFEV_: 'FFEV_',
  FFIN_: 'FFIN_',
  FFOV_: 'FFOV_',
  FFSE_: 'FFSE_',
  FHWL_: 'FHWL_',
  FOAP_: 'FOAP_',
  FOEX_: 'FOEX_',
  FOFA_: 'FOFA_',
  FOFR_: 'FOFR_',
  FWCF_: 'FWCF_',
  FWCG_: 'FWCG_',
  GLAC_: 'GLAC_',
  GLIE_: 'GLIE_',
  HYPE_: 'HYPE_',
  HYPO_: 'HYPO_',
  INCL_: 'INCL_',
  INER_: 'INER_',
  INTD_: 'INTD_',
  INTE_: 'INTE_',
  INTO_: 'INTO_',
  INTR_: 'INTR_',
  INVR_: 'INVR_',
  ITAO_: 'ITAO_',
  ITFC_: 'ITFC_',
  ITIR_: 'ITIR_',
  ITQI_: 'ITQI_',
  ITQU_: 'ITQU_',
  ITRE_: 'ITRE_',
  ITRI_: 'ITRI_',
  ITRR_: 'ITRR_',
  IWFC_: 'IWFC_',
  MALE_: 'MALE_',
  NDOC_: 'NDOC_',
  NDTE_: 'NDTE_',
  NOCG_: 'NOCG_',
  PITA_: 'PITA_',
  POTX_: 'POTX_',
  RPTR_: 'RPTR_',
  SECL_: 'SECL_',
  SOFC_: 'SOFC_',
  SOHW_: 'SOHW_',
  SOWN_: 'SOWN_',
  SOWV_: 'SOWV_',
  STEV_: 'STEV_',
  TBLE_: 'TBLE_',
  TCCG_: 'TCCG_',
  TCCR_: 'TCCR_',
  TRCO_: 'TRCO_',
  TRCY_: 'TRCY_',
  USER_: 'USER_',
  WFCG_: 'WFCG_',
  WFCP_: 'WFCP_',
  WFRN_: 'WFRN_',
  WFTM_: 'WFTM_',
  WFTR_: 'WFTR_',
  WFTX_: 'WFTX_',
  WTFL_: 'WTFL_',
  WTHP_: 'WTHP_',
} as const;
